module.exports = __webpack_public_path__ + "static/media/gold-coins-1_1.e87b1154.png";